import { Attr, Model } from 'spraypaint';

import { ApplicationRecord } from './application_record';

// One thing that happened while a boot looked for capacity: an attempt to
// start an instance type, a switch to the next type, or the auto scaling group
// recreating the instance in another zone.
@Model()
export default class WorkstationBootAttempt extends ApplicationRecord {
  static jsonapiType = 'workstation_boot_attempts';
  @Attr() instanceTypeIdentifier: string;
  // usw2-az2 form during start attempts, us-west-2a form for recreate rows.
  @Attr() availabilityZone: string;
  @Attr() phase: string;
  @Attr() outcome: string;
  @Attr() attemptNumber: number;
  @Attr() maxAttempts: number;
  @Attr() message: string;
  @Attr() createdAt: string;
}
